<div *ngIf="loading" class="pdf-loading-overlay">

  <div class="pdf-card">

    <!-- ICONO PRO -->
    <div class="pdf-icon-container">

      <!-- hojas atrás -->
      <div class="pdf-layer layer-1"></div>
      <div class="pdf-layer layer-2"></div>

      <!-- hoja principal -->
      <div class="pdf-main">
        <span>PDF</span>
      </div>

      <!-- glow -->
      <div class="pdf-glow"></div>

      <!-- partículas -->
      <div class="particles">
        <span></span>
        <span></span>
        <span></span>
      </div>

    </div>

    <h3>Generando PDF</h3>
    <p>{{ loadingText }}</p>

    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress" [style.width.%]="progress"></div>
      </div>
      <!-- <span class="progress-text">{{ progress }}%</span> -->
    </div>

  </div>

</div>